const Footer = () => {
  return (
    <footer className="bg-light text-center py-3">
      <p className="mb-0">© 2024 - 2025 BuddyX. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
